$(document).ready(function () {
    if ($(window).scrollTop() > 0) {
        scaleImg();
        translateBlock();
        scaleText();
        opacityBlock();
    } else {
        setTimeout(() => {
            scaleImg();
            translateBlock();
            scaleText();
            opacityBlock();
        }, 500)
    }
    
    $(window).scroll(function () {
        scaleImg();
        translateBlock();
        scaleText();
        opacityBlock();
    });

    function isElementInViewport(el) {
        var rect = el.getBoundingClientRect();
        var windowHeight = (window.innerHeight || document.documentElement.clientHeight) + 300;

        return (
            rect.top <= windowHeight / 2 &&
            rect.bottom >= windowHeight / 2
        );
    }


    function scaleImg() {
        $('.js__scale_img').each(function () {
            const animation = $(this).attr('data-animation');
            if (typeof animation === 'undefined' && isElementInViewport(this)) {
                $(this).find('.scale_img').removeClass('scale_img');
                $(this).attr('data-animation', 'over');
            }
        });
    }

    function scaleText() {
        $('.js__scale_text').each(function () {
            const animation = $(this).attr('data-animation');
            if (typeof animation === 'undefined' && isElementInViewport(this)) {
                $(this).find('.scale_text').removeClass('scale_text');
                $(this).attr('data-animation', 'over');
            }
        });
    }

    function translateBlock() {
        $('.js__translate').each(function () {
            const animation = $(this).attr('data-animation');
            if (typeof animation === 'undefined' && isElementInViewport(this)) {
                $(this).find('.translate').removeClass('translate_animation');
                $(this).attr('data-animation', 'over');
            }
        });
    }

    function opacityBlock() {
        $('.js__opacity').each(function () {
            const animation = $(this).attr('data-animation');
            if (typeof animation === 'undefined' && isElementInViewport(this)) {
                $(this).find('.opacity').removeClass('opacity');
                $(this).attr('data-animation', 'over');
            }
        });
    }
});
